var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vector",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M58.003,8H5.997c-3.314,0 -6,2.686 -6,6v36c0,3.314 2.686,6 6,6h52.007c3.314,0 6,-2.686 6,-6V14C64.003,10.686 61.317,8 58.003,8zM62.003,49.111L43.085,30.192l18.919,-12.056V49.111zM5.997,10h52.007c2.206,0 4,1.794 4,4v1.766L34.468,33.313c-1.49,0.949 -3.394,0.92 -4.85,-0.07L1.997,14.469V14C1.997,11.794 3.791,10 5.997,10zM1.997,16.885L21.182,29.925L1.997,49.111V16.885zM58.003,54H5.997c-1.647,0 -3.064,-1.002 -3.676,-2.428l20.52,-20.52l5.655,3.843c1.086,0.738 2.342,1.108 3.6,1.108c1.195,0 2.393,-0.334 3.446,-1.005l5.842,-3.723l20.296,20.296C61.067,52.998 59.651,54 58.003,54z",
    id: "path_0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailLogo);
export default __webpack_public_path__ + "static/media/mail_logo.2a0b8a7d671015bc7719b9b01fe1a65a.svg";
export { ForwardRef as ReactComponent };